/*
  PG Bundle layouts — behaviour for the pg-bundle-* sections.
  Loaded by every pg-bundle section but runs once. Handles:
  galleries, bundle panels (choice, price, add to cart), the optional add-on,
  countdowns and the mobile sticky offer bar. Re-binds when the theme editor
  reloads a section. No product handles or IDs here: everything comes from data
  attributes written by the sections.
*/
(function () {
  if (window.PGBundle) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var addOn = { checked: false, available: false, variantId: 0, price: 0, title: '' };

  function $all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  /* ── Gallery ── */
  function initGallery(gallery) {
    if (gallery.__pgb) return;
    gallery.__pgb = true;
    var slides = $all(gallery, '[data-pgb-slide]');
    var thumbs = $all(gallery, '[data-pgb-thumb]');
    var current = 0;
    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }
    show(0);
    var prev = gallery.querySelector('[data-pgb-prev]');
    var next = gallery.querySelector('[data-pgb-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { show(i); }); });
    gallery.addEventListener('keydown', function (e) {
      if (slides.length < 2) return;
      if (e.key === 'ArrowLeft') { show(current - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { show(current + 1); e.preventDefault(); }
    });
    var startX = null;
    var frame = gallery.querySelector('[data-pgb-frame]');
    if (frame && slides.length > 1) {
      frame.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) >= 50) show(dx < 0 ? current + 1 : current - 1);
        startX = null;
      }, { passive: true });
    }
  }

  /* ── Add-on ── */
  function initAddOn(box) {
    if (box.__pgb) return;
    box.__pgb = true;
    var input = box.querySelector('[data-pgb-addon-input]');
    addOn.available = box.getAttribute('data-available') === 'true' && box.getAttribute('data-preview') !== 'true';
    addOn.variantId = parseInt(box.getAttribute('data-variant-id'), 10) || 0;
    addOn.price = parseInt(box.getAttribute('data-price'), 10) || 0;
    addOn.title = box.getAttribute('data-title') || '';
    if (!input) return;
    if (!addOn.available || !addOn.variantId) {
      input.checked = false;
      input.disabled = true;
      addOn.checked = false;
      return;
    }
    addOn.checked = input.checked;
    input.addEventListener('change', function () {
      addOn.checked = input.checked;
      box.setAttribute('data-selected', input.checked ? 'true' : 'false');
      emit('pgb:addon', { checked: input.checked });
    });
  }

  function activeAddOn() {
    return addOn.checked && addOn.available && addOn.variantId ? addOn : null;
  }

  /* ── Bundle panel ── */
  function initPanel(panel) {
    if (panel.__pgb) return;
    panel.__pgb = true;
    var productId = panel.getAttribute('data-product-id');
    var requireChoice = panel.getAttribute('data-require-choice') === 'true';
    var initialId = parseInt(panel.getAttribute('data-initial-variant'), 10) || 0;
    var textSoldOut = panel.getAttribute('data-text-sold-out') || 'Sold out';
    var textError = panel.getAttribute('data-text-error') || 'Something went wrong. Please try again.';
    var trialVariantId = parseInt(panel.getAttribute('data-trial-variant'), 10) || 0;
    var trialPlanId = parseInt(panel.getAttribute('data-trial-plan'), 10) || 0;
    var variants = [];
    var json = panel.querySelector('[data-pgb-variants]');
    if (json) {
      try { variants = JSON.parse(json.textContent); } catch (err) { variants = []; }
    }
    var groups = $all(panel, '[data-pgb-choice][data-option-index]');
    var priceEls = $all(panel, '[data-pgb-price]');
    var note = panel.querySelector('[data-pgb-addon-note]');
    var prompt = panel.querySelector('[data-pgb-prompt]');
    var errorEl = panel.querySelector('[data-pgb-error]');
    var button = panel.querySelector('[data-pgb-buy]');
    var label = panel.querySelector('[data-pgb-buy-label]');
    var ctaText = label ? label.textContent : '';
    var pending = false;

    function chosen() {
      return groups.map(function (g) {
        var input = g.querySelector('[data-pgb-option-input]:checked');
        return input ? input.value : null;
      });
    }

    // Fixed main variant (e.g. the 6-month supply) and/or a free companion product whose
    // options drive the choice buttons (e.g. SpeedTrac hand).
    var fixedMain = panel.getAttribute('data-fixed-main') === 'true';
    var companionMode = panel.getAttribute('data-companion') === 'true';
    var companionVariants = [];
    var cjson = panel.querySelector('[data-pgb-companion-variants]');
    if (cjson) {
      try { companionVariants = JSON.parse(cjson.textContent); } catch (err) { companionVariants = []; }
    }

    function byId(list, id) {
      for (var k = 0; k < list.length; k++) if (list[k].id === id) return list[k];
      return list[0] || null;
    }

    function matchChoice(list) {
      var picks = chosen();
      if (picks.indexOf(null) > -1) return null;
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        var match = groups.every(function (g, gi) {
          return v.options[parseInt(g.getAttribute('data-option-index'), 10)] === picks[gi];
        });
        if (match) return v;
      }
      return null;
    }

    function current() {
      if (!variants.length) return null;
      if (fixedMain || companionMode || !groups.length) return byId(variants, initialId);
      return matchChoice(variants);
    }

    function companion() {
      if (!companionMode || !companionVariants.length) return null;
      if (!groups.length) {
        return companionVariants.filter(function (v) { return v.available; })[0] || companionVariants[0];
      }
      return matchChoice(companionVariants);
    }

    // What the companion costs once the admin discount applies (cents); 0 = free.
    var companionCharge = companionMode ? (parseInt(panel.getAttribute('data-companion-charge'), 10) || 0) : 0;

    function basePrice() {
      var v = current() || byId(variants, initialId);
      return v ? v.price + companionCharge : null;
    }

    function render() {
      var base = basePrice();
      var extra = activeAddOn();
      var total = base == null ? null : base + (extra ? extra.price : 0);
      priceEls.forEach(function (el) { if (total != null) el.textContent = money(total); });
      if (note) {
        note.hidden = !extra;
        note.textContent = extra ? '+ ' + extra.title + ' ' + money(extra.price) : '';
      }
      var v = current();
      var c = companion();
      if (button && label) {
        var soldOut = (v && !v.available) || (c && !c.available);
        button.disabled = pending || !!soldOut;
        label.textContent = pending ? 'Adding…' : soldOut ? textSoldOut : ctaText;
      }
      panel.__pgbTotal = total;
      emit('pgb:panel-render', { productId: productId, base: base, total: total });
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function () {
        group.classList.remove('is-invalid');
        if (prompt && chosen().indexOf(null) === -1) prompt.hidden = true;
        render();
        emit('pgb:select', { productId: productId, options: chosen(), source: panel });
      });
    });

    // Keep every panel for the same product on the same choice.
    document.addEventListener('pgb:select', function (e) {
      if (!e.detail || e.detail.source === panel || e.detail.productId !== productId) return;
      groups.forEach(function (g, gi) {
        var value = e.detail.options[gi];
        if (value == null) return;
        $all(g, '[data-pgb-option-input]').forEach(function (input) { input.checked = input.value === value; });
        g.classList.remove('is-invalid');
      });
      if (prompt) prompt.hidden = true;
      render();
    });
    document.addEventListener('pgb:addon', render);
    render();

    var form = panel.querySelector('[data-pgb-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (pending) return;
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      var v = current();
      var c = companion();
      if (!v || (companionMode && !c)) {
        if (groups.length) {
          var missing = groups.filter(function (g) { return !g.querySelector('[data-pgb-option-input]:checked'); });
          missing.forEach(function (g) { g.classList.add('is-invalid'); });
          if (prompt && prompt.textContent.trim()) prompt.hidden = false;
          var first = missing.length ? missing[0].querySelector('[data-pgb-option-input]') : null;
          if (first) first.focus();
        }
        return;
      }
      if (!v.available || (c && !c.available)) return;
      var items = [{ id: v.id, quantity: 1 }];
      if (c) items.push({ id: c.id, quantity: 1 });
      var extra = activeAddOn();
      if (extra) items.push({ id: extra.variantId, quantity: 1 });
      pending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Adding…';

      // PG1 free-trial auto-add: same rule as the other PG buy boxes.
      var prepare = Promise.resolve(items);
      if (trialVariantId) {
        var props = { '_pg08_bundle': 'true', '_pg08_bundle_mode': 'pg1-free-trial-oneway' };
        items[0].properties = props;
        var trial = { id: trialVariantId, quantity: 1, properties: props };
        if (trialPlanId) trial.selling_plan = trialPlanId;
        prepare = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var inCart = (cart.items || []).some(function (line) { return line.variant_id === trialVariantId; });
            if (!inCart) items.push(trial);
            return items;
          });
      }

      prepare
        .then(function (list) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: list })
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error((data && (data.description || data.message)) || textError);
            return data;
          });
        })
        .then(function () {
          if (trialVariantId) {
            try { sessionStorage.setItem('pg08_bundle_active', '1'); } catch (err) {}
          }
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
          pending = false;
          button.disabled = false;
          button.setAttribute('aria-busy', 'false');
          if (label) label.textContent = ctaText;
          if (panel.getAttribute('data-cart-destination') === 'cart' || !window.theme || !window.theme.hasCartDrawer) window.location.href = '/cart';
        })
        .catch(function (err) {
          pending = false;
          button.disabled = false;
          button.setAttribute('aria-busy', 'false');
          if (label) label.textContent = ctaText;
          if (errorEl) {
            errorEl.textContent = err && err.message ? err.message : textError;
            errorEl.hidden = false;
          }
        });
    });
  }

  /* ── Add-on running total (bundle + add-on) ── */
  function updateAddOnTotals(detail) {
    $all(document, '[data-pgb-addon-total]').forEach(function (el) {
      var extra = activeAddOn();
      var base = detail && detail.base != null ? detail.base : null;
      if (!extra || base == null) { el.hidden = true; return; }
      var label = el.getAttribute('data-label') || '';
      el.textContent = (label ? label + ' ' : '') + money(base + extra.price);
      el.hidden = false;
    });
  }
  var lastRender = null;
  document.addEventListener('pgb:panel-render', function (e) { lastRender = e.detail; updateAddOnTotals(lastRender); });

  /* Visible-only UGC previews, matching PG UGC Carousel. Sound is opt-in. */
  function initVideo(card) {
    if (card.__pgbVideo) return;
    card.__pgbVideo = true;
    var video = card.querySelector('video');
    var button = card.querySelector('[data-pgb-video-play]');
    if (!video || !button) return;
    function preview() {
      video.muted = true;
      video.loop = true;
      video.controls = false;
      card.classList.remove('is-activated');
      button.hidden = false;
    }
    function silenceOthers() {
      $all(document, '[data-pgb-video-card]').forEach(function (other) {
        if (other === card) return;
        var v = other.querySelector('video');
        var b = other.querySelector('[data-pgb-video-play]');
        if (v) { v.muted = true; v.loop = true; v.controls = false; }
        other.classList.remove('is-activated');
        if (b) b.hidden = false;
      });
    }
    button.addEventListener('click', function () {
      silenceOthers();
      video.currentTime = 0;
      video.muted = false;
      video.loop = false;
      video.controls = true;
      card.classList.add('is-activated');
      video.play().then(function () { button.hidden = true; }).catch(preview);
    });
    video.addEventListener('volumechange', function () {
      if (!video.muted) silenceOthers();
    });
    video.addEventListener('ended', preview);
    preview();
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!reduceMotion) video.play().catch(function () {});
          } else {
            video.pause();
            preview();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(card);
    }
  }

  /* ── Countdown ── */
  function initCountdown(box) {
    if (box.__pgb) return;
    box.__pgb = true;
    var start = Date.parse(box.getAttribute('data-start') || '');
    var end = Date.parse(box.getAttribute('data-end') || '');
    if (isNaN(end)) return;
    var labelEl = box.querySelector('[data-pgb-countdown-label]');
    var parts = {
      d: box.querySelector('[data-pgb-d]'),
      h: box.querySelector('[data-pgb-h]'),
      m: box.querySelector('[data-pgb-m]'),
      s: box.querySelector('[data-pgb-s]')
    };
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var now = Date.now();
      var label;
      var target;
      if (!isNaN(start) && now < start) { label = box.getAttribute('data-label-before'); target = start; }
      else if (now <= end) { label = box.getAttribute('data-label-during'); target = end; }
      else { label = box.getAttribute('data-label-after'); target = now; }
      if (!label) { box.hidden = true; return; }
      box.hidden = false;
      labelEl.textContent = label;
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      parts.d.textContent = Math.floor(diff / 86400);
      parts.h.textContent = pad(Math.floor((diff % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((diff % 3600) / 60));
      parts.s.textContent = pad(diff % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Mobile sticky offer ── */
  function initSticky(bar) {
    if (bar.__pgb || !('IntersectionObserver' in window)) return;
    bar.__pgb = true;
    var owner = bar.closest('.pgb');
    var ownPanel = owner ? owner.querySelector('[data-pgb-panel]') : null;
    var panels = $all(document, '[data-pgb-panel]');
    var visible = new Set();
    var past = false;
    var button = bar.querySelector('[data-pgb-sticky-button]');
    var price = bar.querySelector('[data-pgb-sticky-price]');
    function update() {
      var show = past && visible.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (button) button.tabIndex = show ? 0 : -1;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
        if (entry.target === ownPanel) past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      update();
    });
    panels.forEach(function (p) { io.observe(p); });
    document.addEventListener('pgb:panel-render', function (e) {
      if (price && e.detail && e.detail.total != null) price.textContent = money(e.detail.total);
    });
    if (button) {
      button.addEventListener('click', function () {
        var target = null;
        var best = Infinity;
        panels.forEach(function (p) {
          var d = Math.abs(p.getBoundingClientRect().top);
          if (d < best) { best = d; target = p; }
        });
        if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  function init(root) {
    root = root || document;
    $all(root, '[data-pgb-gallery]').forEach(initGallery);
    $all(root, '[data-pgb-addon]').forEach(initAddOn);
    $all(root, '[data-pgb-panel]').forEach(initPanel);
    $all(root, '[data-pgb-video-card]').forEach(initVideo);
    $all(root, '[data-pgb-countdown]').forEach(initCountdown);
    $all(root, '[data-pgb-sticky]').forEach(initSticky);
  }

  window.PGBundle = { init: init, money: money };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
